// extracted by mini-css-extract-plugin
export var paginationContainer = "_89-0";